import {
  openForethoughtWidget,
  updateForethoughtContext,
} from "../components/services/ForethoughtChatbot";
import { segmentAnalytics } from "../components/services/Analytics";
import { SUPPORT_CLICKED } from "../constants/eventsTracked";

export interface CustomerDetails {
  customerId: string;
  customerName: string;
  customerSiteUrl: string;
}

export interface CatalogItemDetails {
  itemId: string;
  itemTitle: string;
  itemImage: string;
  customerName: string;
  customerSiteUrl: string;
}

const launchForethought = (
  supportType: string,
  { customerId, customerName, customerSiteUrl }: CustomerDetails
): void => {
  segmentAnalytics.track(SUPPORT_CLICKED, {
    support_type: supportType,
  });
  updateForethoughtContext({
    store_id: customerId,
    store_name: customerName,
    store_url: customerSiteUrl,
  });
  openForethoughtWidget();
};

export const launchForethoughtSupport = (details: CustomerDetails): void =>
  launchForethought("Forethought Helpbot", details);

export const launchForethoughtCatalogIssue = (
  details: CatalogItemDetails
): void => {
  segmentAnalytics.track(SUPPORT_CLICKED, {
    support_type: "Report Catalog Issue",
  });
  updateForethoughtContext({
    catalog_item_id: details.itemId,
    catalog_item_title: details.itemTitle,
    store_name: details.customerName,
    store_url: details.customerSiteUrl,
    catalog_item_image: details.itemImage,
    catalog_item_shopify_link: `https://${details.customerSiteUrl}/admin/products/${details.itemId}`,
  });
  openForethoughtWidget();
};

export const launchForethoughtBugReport = (details: CustomerDetails): void =>
  launchForethought("Report a Bug", details);
